let UnitMatrix = {};

//from to
UnitMatrix["grams"] = 1;
UnitMatrix["metric tonne"] = 1000000;
UnitMatrix["short ton"] = 907184.74;
UnitMatrix["kilogram"] = 1000;
UnitMatrix["pound"] = 453.59237;
UnitMatrix["bushel 60 lb"] = 27215.5422;
UnitMatrix["bushel 56 lb"] = 25401.17272;
UnitMatrix["bushel 48 lb"] = 21772.43376;
UnitMatrix["bushel 34 lb"] = 15422.14058;
UnitMatrix["bushel 32 lb"] = 14514.95584;
UnitMatrix["short hundredweight"] = 45359.237;
UnitMatrix["long hundredweight"] = 50802.34544;

export function fromGramsTo(convertTo, valueInGrams, decimalPoints = 3) {
    if (valueInGrams == 0 || valueInGrams == "") {
        return 0;
    }

    convertTo = convertTo.toLowerCase();

    var convertion = UnitMatrix[convertTo];

    if (!convertion) {
        return 0;
    }

    var retVal = valueInGrams / convertion;
    retVal = retVal.toFixed(decimalPoints);

    return retVal;
}

export function toGramsFrom(convertTo, valueIn, decimalPoints = 3) {
    if (valueIn == 0 || valueIn == "") {
        return 0;
    }

    convertTo = convertTo.toLowerCase();

    var convertion = UnitMatrix[convertTo];
    if (!convertion) {
        return 0;
    }

    var retVal = valueIn * convertion;
    retVal = retVal.toFixed(decimalPoints);

    return retVal;
}

export const areaConvFunctions = {
    fromGramsTo,
    toGramsFrom
};
